// Spanish for the home area (pages/Home.js). English text (exact) -> Spanish.
const dict = {
  "Viewing as {name} ({role}) · read-only": "Viendo como {name} ({role}) · solo lectura",
  "Exit": "Salir",
  "View as is read-only. Nothing was saved. (You're viewing as {name}.)": "Ver como es solo lectura. No se guardó nada. (Está viendo como {name}.)",
  "Receipt": "Recibo",
  "Time Window": "Horario",
  "Company": "Compañía",
  "Check Purchased when the material has been bought.": "Marque Comprado cuando el material ya se haya comprado.",
  // Header / banners
  "Loading jobs...": "Cargando trabajos...",
  "Jobs did not finish loading (weak connection?).": "Los trabajos no terminaron de cargar (¿señal débil?).",
  "Try again": "Intentar de nuevo",
  "Welcome to the Portal": "Bienvenido al Portal",
  "Role": "Rol",
  "Tech": "Técnico",
  "Admin": "Administrador",
  "Manager": "Gerente",
  "Assistant": "Asistente",
  "Uploading...": "Subiendo...",
  "Click to change avatar": "Toque para cambiar su foto",
  "Could not upload avatar.": "No se pudo subir la foto.",
  "Today’s Hours": "Horas de Hoy",

  // Tabs / more menu
  "Jobs": "Trabajos",
  "Job Calendar": "Calendario de Trabajos",
  "Clock In / Out": "Marcar Entrada / Salida",
  "Time Log Calendar": "Calendario de Horas",
  "More": "Más",
  "Clock Time": "Horas Marcadas",
  "Customer Codes": "Códigos de Clientes",
  "Maps": "Mapas",
  "Time Off": "Tiempo Libre",

  // Tech job list
  "Today’s Jobs": "Trabajos de Hoy",
  "Tomorrow’s Jobs": "Trabajos de Mañana",
  "This Week’s Jobs": "Trabajos de Esta Semana",
  "Today": "Hoy",
  "Tomorrow": "Mañana",
  "This Week": "Esta Semana",
  "No jobs scheduled for this time frame.": "No hay trabajos programados para este período.",
  "WO #": "OT #",
  "Client WO #": "OT del Cliente #",
  "No Service Type": "Sin tipo de servicio",
  "Date:": "Fecha:",
  "No date": "Sin fecha",
  "Time Window:": "Horario:",
  "Custom ({time})": "Personalizado ({time})",
  "ANY": "Cualquier hora",
  "Company:": "Compañía:",
  "Materials required ({count})": "Materiales requeridos ({count})",
  "View Job": "Ver Trabajo",
  "Start / Resume": "Iniciar / Reanudar",
  "N/A": "N/D",

  // Job detail
  "Site Name:": "Nombre del Sitio:",
  "Work Order:": "Orden de Trabajo:",
  "Client Work Order #:": "Orden de Trabajo del Cliente #:",
  "Address:": "Dirección:",
  "City:": "Ciudad:",
  "State:": "Estado:",
  "Start Date:": "Fecha de Inicio:",
  "End Date:": "Fecha de Fin:",
  "Planned:": "Planificado:",
  "{count} day(s)": "{count} día(s)",
  "{count} people": "{count} personas",
  "Scheduled days do not match estimated job duration": "Los días programados no coinciden con la duración estimada del trabajo",
  "End Time:": "Hora de Fin:",
  "Recurrence:": "Repetición:",
  "One-Time": "Una Vez",
  "Daily": "Diario",
  "Weekly": "Semanal",
  "Bi-Weekly": "Cada Dos Semanas",
  "Monthly": "Mensual",
  "Bi-Monthly": "Cada Dos Meses",
  "Quarterly": "Trimestral",
  "Bi-Yearly": "Semestral",
  "Yearly": "Anual",
  "Custom Dates": "Fechas Personalizadas",
  "Days:": "Días:",
  "Custom Dates:": "Fechas Personalizadas:",
  "Service Type:": "Tipo de Servicio:",
  "Scope:": "Alcance:",
  "Job Description:": "Descripción del Trabajo:",
  "Client Phone:": "Teléfono del Cliente:",
  "Client Email:": "Correo del Cliente:",
  "Tech Assign:": "Técnicos Asignados:",
  "Status:": "Estado:",
  "Unassigned": "Sin asignar",
  "Active": "Activo",
  "Completed": "Completado",
  "On Hold": "En Espera",
  "Invoice Sent": "Factura Enviada",
  "Project Completed": "Proyecto Completado",
  "Project Job — Day {day}": "Trabajo de Proyecto — Día {day}",
  "Created On:": "Creado el:",
  "Created By:": "Creado por:",
  "Unknown": "Desconocido",

  // Materials (detail)
  "Materials": "Materiales",
  "Mark as purchased": "Marcar como comprado",
  "Mark as not purchased": "Marcar como no comprado",
  "Unnamed material": "Material sin nombre",
  "Qty:": "Cant.:",
  "Cost Per:": "Costo c/u:",
  "Estimated:": "Estimado:",
  "Purchase Location:": "Lugar de Compra:",
  "Material Notes:": "Notas del Material:",
  "Purchased": "Comprado",
  "Not Purchased": "No Comprado",
  "Total Estimated Material Cost:": "Costo Total Estimado de Materiales:",
  "No materials listed.": "No hay materiales en la lista.",

  // Receipts
  "Receipts": "Recibos",
  "Receipt Total:": "Total de Recibos:",
  "Uploaded by {name}": "Subido por {name}",
  "View Receipt Image": "Ver Imagen del Recibo",
  "No receipts added.": "No se han agregado recibos.",

  // Notes / files
  "Notes": "Notas",
  "View Attachment {n}": "Ver Archivo Adjunto {n}",
  "No notes yet for this occurrence.": "Todavía no hay notas para esta visita.",
  "Uploaded Files": "Archivos Subidos",
  "View File {n}": "Ver Archivo {n}",
  "New Attachments": "Archivos Nuevos",

  // Actions
  "Supervisor": "Supervisor",
  "History": "Historial",
  "Change Total": "Cambiar Total",
  "Add Total": "Agregar Total",
  "Add Note": "Agregar Nota",
  "Mark Job as Completed": "Marcar Trabajo como Completado",
  "Sent to Office ✓": "Enviado a la Oficina ✓",
  "Add Receipt": "Agregar Recibo",
  "Add / Edit Materials": "Agregar / Editar Materiales",
  "Checklist": "Lista de Verificación",
  "Close": "Cerrar",
  "Check in to this job first.\n\nTap Check In when you arrive so your time and location are recorded, then mark it completed.":
    "Primero registre su llegada a este trabajo.\n\nToque Registrar Llegada cuando llegue para que se guarden su hora y ubicación, y después márquelo como completado.",
  "Could not mark job completed.": "No se pudo marcar el trabajo como completado.",

  // Materials popup
  "Check Purchased when the material has been bought. Estimated Material Cost is calculated automatically from Qty × Cost Per.":
    "Marca Comprado cuando el material ya se compró. El Costo Estimado de Materiales se calcula automáticamente con Cant. × Costo c/u.",
  "Remove": "Quitar",
  "Product": "Producto",
  "Example: 2x4 pressure-treated lumber": "Ejemplo: madera tratada 2x4",
  "Qty": "Cant.",
  "Cost Per": "Costo c/u",
  "Estimated Material Cost": "Costo Estimado del Material",
  "Purchase Location": "Lugar de Compra",
  "Example: Home Depot - Leesburg": "Ejemplo: Home Depot - Leesburg",
  "Material Notes": "Notas del Material",
  "Color, size, model number, pickup instructions, or other notes": "Color, tamaño, número de modelo, instrucciones para recoger u otras notas",
  "Photos / Files": "Fotos / Archivos",
  "Remove file": "Quitar archivo",
  "Add Material": "Agregar Material",
  "Save Materials": "Guardar Materiales",
  "Cancel": "Cancelar",
  "Could not save materials. Please try again.": "No se pudieron guardar los materiales. Intente de nuevo.",

  // Receipt popup
  "Receipt Amount": "Monto del Recibo",
  "Enter receipt amount": "Escriba el monto del recibo",
  "Receipt Note": "Nota del Recibo",
  "Example: Home Depot materials": "Ejemplo: materiales de Home Depot",
  "Upload Receipt Image": "Subir Imagen del Recibo",
  "Selected: {name}": "Seleccionado: {name}",
  "Saving...": "Guardando...",
  "Save Receipt": "Guardar Recibo",
  "Please add a receipt amount or upload a receipt image.": "Agrega el monto del recibo o sube una imagen del recibo.",
  "Could not save receipt.": "No se pudo guardar el recibo.",

  // Note popup
  "Enter your note here...": "Escriba su nota aquí...",
  "Saving note...": "Guardando nota...",
  "Save": "Guardar",
  "There was an error saving your note. Please try again.": "Hubo un error al guardar su nota. Intente de nuevo.",

  // Total popup
  "Original contract total ($)": "Total original del contrato ($)",
  "Total Amount ($)": "Monto Total ($)",
  "Enter amount": "Escriba el monto",
  "Reason (required)": "Motivo (obligatorio)",
};

export default dict;
